import { createSlice } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import endpoints from "../config/endpoints";
import { apiGet, apiPost } from "../utils/api_service";
const initialState = {
  dayWiseBeatAssign: [],
};
let URL = endpoints.vehicleAssignDayWiseHeader;
const vehicleAssignSlice = createSlice({
  name: "vehicleAssign",
  initialState,
  reducers: {

    dayWiseBeatAssignSuccess: (state = cloneDeep(initialState), action) => {
      const { row } = action.payload;
      return {
        ...state,
        dayWiseBeatAssign: row,
      };
    },

    resetState: (state = cloneDeep(initialState), action) => {
      return {
        ...state,
        ...initialState,
      };
    },
  },
});

export const { dayWiseBeatAssignSuccess, resetState } =
  vehicleAssignSlice.actions;

export default vehicleAssignSlice.reducer;

export const getVehicleAssignDayWise = () => async (dispatch) => {
  try {
    const response = apiGet({
      url: URL + "/get-all",
    }).then(({ data, success }) => {
      if (success) {
        const row = data.data.map((vehicleObject, index) => {
          let vehicleData = {
            index: index + 1,
            id: vehicleObject.id === null ? "" : vehicleObject.id,
            driverName:
              vehicleObject.driverName === null ? "" : vehicleObject.driverName,
            noOfBeat:
              vehicleObject.noOfBeat === null ? "" : vehicleObject.noOfBeat,
            noOfOutlet:
              vehicleObject.noOfOutlet === null ? "" : vehicleObject.noOfOutlet,
            name:
              vehicleObject.vehicleNo === null ? "" : vehicleObject.vehicleNo,
            vehicleNo:
              vehicleObject.vehicleNo === null ? "" : vehicleObject.vehicleNo,
            isActive:
              vehicleObject.isActive === null ? "" : vehicleObject.isActive,
          };
          return vehicleData;
        });
        dispatch(dayWiseBeatAssignSuccess({ row }));
        return { response: row, success };
      }
      return { response: [], success };
    });
    return response;
  } catch (e) {
    return console.error(e.message);
  }
};

export const getUpdatedDayWiseBeatOutletCountFromAreas =
  ({ areaIdsData }) =>
    async (dispatch) => {
      try {
        const response = apiPost({
          url: URL + "/by-areas-with-beat-outlet-count",
          postBody: areaIdsData,
        }).then(({ data, success }) => {
          if (success) {
            const row = data.data.map((categoryObject, index) => {
              let categoryData = {
                index: index + 1,
                id: categoryObject.id === null ? "" : categoryObject.id,
                driverName:
                  categoryObject.driverName === null
                    ? ""
                    : categoryObject.driverName,
                noOfBeat:
                  categoryObject.noOfBeat === null ? "" : categoryObject.noOfBeat,
                noOfOutlet:
                  categoryObject.noOfOutlet === null
                    ? ""
                    : categoryObject.noOfOutlet,
                name:
                  categoryObject.vehicleNo === null
                    ? ""
                    : categoryObject.vehicleNo,
                vehicleNo:
                  categoryObject.vehicleNo === null
                    ? ""
                    : categoryObject.vehicleNo,
                isActive:
                  categoryObject.isActive === null ? "" : categoryObject.isActive,
              };
              return categoryData;
            });
            dispatch(dayWiseBeatAssignSuccess({ row }));
            return { response: row, success };
          }
          return { response: [], success };
        });
        return response;
      } catch (e) {
        return console.error(e.message);
      }
    };
